import {
  BADGE_OFFSET_MULTIPLIER,
  CENTERX_DIVIDER,
  CENTERY_DIVIDER,
  SCALE_DIVIDER,
  SCALE_MULTIPLIER,
} from './constants';
import { ResourceOccupationStatusEnum } from './resource-occupation-status.enum';

export const getSvgProperties = (
  x: number,
  y: number,
  radius: number,
  size: number,
  occupationStatus?: ResourceOccupationStatusEnum
) => {
  const centerX = x + size / CENTERX_DIVIDER;
  const centerY = y + size / CENTERY_DIVIDER;
  const scale = (radius * SCALE_MULTIPLIER) / SCALE_DIVIDER;
  const badgeOffset = radius * BADGE_OFFSET_MULTIPLIER;
  const shouldShowOccupationBadge =
    !!occupationStatus &&
    [ResourceOccupationStatusEnum.Occupied, ResourceOccupationStatusEnum.Unknown].includes(occupationStatus);

  return {
    centerX,
    centerY,
    scale,
    badgeOffset,
    shouldShowOccupationBadge,
  };
};
